/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField, TitleField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Form } from '@organisms';
import { Typography, Block, ErrorMessage } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';

import { FORM_FIELD } from './constants';

const MinisiteForm = ({ initialValues = {}, error, form }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <TextField {...FORM_FIELD.NAME} style={NO_MARGIN_BOTTOM} />
      </Block>
      <Block spaced>
        <Typography.Title level={3} style={{ marginBottom: '30px' }}>
          Appearance
        </Typography.Title>
        <MediaField {...FORM_FIELD.LOGO} />
        <MediaField {...FORM_FIELD.FEATURE_IMAGE} />
        <TitleField {...FORM_FIELD.PRIMARY_COLOR} extra={null} wrapperCol={{ span: 24 }} />
        <TitleField {...FORM_FIELD.SECONDARY_COLOR} extra={null} wrapperCol={{ span: 24 }} style={NO_MARGIN_BOTTOM} />
      </Block>
    </Form>
  );
};

MinisiteForm.useForm = () => Form.useForm(FORM_FIELD);

export default MinisiteForm;
